(function ( $ ) {
     $.fn.ajaxForm = function (options) {
        var objLink    = $(this);
        var message    = $('.message');
        var gToken      = '';

        function _init() {
            grecaptcha.ready(function() {

                grecaptcha.execute($(objLink).attr('data-sitekey'), {action:'validate_captcha'})
                          .then(function(token) {
                    gToken = token;

                });
            });

            $( objLink ).submit(function( evt ) {
                evt.preventDefault();


                if(gToken == "") {
                    $(message).addClass('error');
                    $(message).html('<p>Při zpracování formuláře došle k chybě, zkuste jej odeslat znovu prosím.</p>');
                } else {
                    $(objLink).addClass('loading');
                    $(objLink).append('<input type="hidden" name="token" value="'+gToken+'" />');


                    //var formData = new FormData($(objLink)[0]);

                    $.ajax({
                        url: $(objLink).attr('action'),
                        type: "POST",
                        //data: formData,
                        data: $(objLink).serialize(),
                        dataType: 'json',
                        async: false,
                        contentType: 'application/json; charset=utf-8',
                        success: function(msg) {
                            if(msg.success == true){
                                $(message).removeClass('error');
                                $(message).html('<p>'+msg.message+'</p>');

                                $("form.js-ajax-form")[0].reset();

                                $(objLink).removeClass('loading');

                            }else{
                                $(message).html('<p>'+msg.message+'</p>');
                                $(message).addClass('error');
                                $(objLink).removeClass('loading');
                            }
                        }
                    });
                }

            });
        }

        _init();

       return {
         reload:_init,
       };
    };
}( jQuery ));

$("form.js-ajax-form").ajaxForm();
